var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 25,
    viewBox: "0 0 8 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.51562 8.98438C1.57227 8.98438 0 10.5566 0 12.5C0 14.4434 1.57227 16.0156 3.51562 16.0156C5.45898 16.0156 7.03125 14.4434 7.03125 12.5C7.03125 10.5566 5.45898 8.98438 3.51562 8.98438ZM3.51562 14.0771C2.64648 14.0771 1.93848 13.3691 1.93848 12.5C1.93848 11.6309 2.64648 10.9229 3.51562 10.9229C4.38477 10.9229 5.09277 11.6309 5.09277 12.5C5.09277 13.3691 4.38477 14.0771 3.51562 14.0771Z",
    fill: "#1E3799"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.51562 0C1.57227 0 0 1.57227 0 3.51562C0 5.45898 1.57227 7.03125 3.51562 7.03125C5.45898 7.03125 7.03125 5.45898 7.03125 3.51562C7.03125 1.57227 5.45898 0 3.51562 0ZM3.51562 5.09277C2.64648 5.09277 1.93848 4.38477 1.93848 3.51562C1.93848 2.64648 2.64648 1.93848 3.51562 1.93848C4.38477 1.93848 5.09277 2.64648 5.09277 3.51562C5.09277 4.38477 4.38477 5.09277 3.51562 5.09277Z",
    fill: "#1E3799"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49219 24.0234C4.49219 23.4863 4.05273 23.0469 3.51562 23.0469C2.65625 23.0469 1.95312 22.3438 1.95312 21.4844C1.95312 20.625 2.65625 19.9219 3.51562 19.9219C4.375 19.9219 5.07812 20.625 5.07812 21.4844C5.07812 22.0215 5.51758 22.4609 6.05469 22.4609C6.5918 22.4609 7.03125 22.0215 7.03125 21.4844C7.03125 19.5459 5.4541 17.9688 3.51562 17.9688C1.57715 17.9688 0 19.5459 0 21.4844C0 23.4229 1.57715 25 3.51562 25C4.05273 25 4.49219 24.5605 4.49219 24.0234Z",
    fill: "#1E3799"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActMenu);
export default __webpack_public_path__ + "static/media/act_menu.62423966b1bad34ef31950478e193b2a.svg";
export { ForwardRef as ReactComponent };